import React from "react";
import { Link } from "react-router-dom";
import DefaultData from "../../CompanyData/DefaultData"; // Adjust the path if DefaultData.js is located elsewhere

const AccountTabs = (props) => {
  const baseTabStyle = {
    border: "none",
    fontWeight: "500",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.375rem 0.375rem 0 0",
  };
  const inactiveTabStyle = {
    ...baseTabStyle,
    backgroundColor: "transparent",
    color: DefaultData.THEMECOLOR3,
    opacity: 2,
  };
  const activeTabStyle = {
    ...baseTabStyle,
    backgroundColor: DefaultData.THEMECOLOR2,
    color: DefaultData.THEMECOLOR3,
  };
  const getStyle = (pageName) =>
    props.pageName === pageName ? activeTabStyle : inactiveTabStyle;

  return (
    <div
      style={{
        backgroundColor: DefaultData.THEMECOLOR5,
        padding: "0 1rem",
        borderBottom: `1px solid ${DefaultData.THEMECOLOR2}`,
      }}
    >
      <ul className="nav nav-tabs" style={{ borderBottom: "none" }}>
      
        <li className="nav-item" role="presentation">
          <Link
            to={"/accounttypes"}
            className="nav-link"
            style={getStyle("ACCOUNTTYPES")}
          >
            ACCOUNT TYPES
          </Link>
        </li>

        <li className="nav-item" role="presentation">
          <Link
            to={"/accounts"}
            className="nav-link"
            style={getStyle("ACCOUNTS")}
          >
            ACCOUNTS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/items"} className="nav-link" style={getStyle("ITEMS")}>
            ITEMS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/accountitems"}
            className="nav-link"
            style={getStyle("ACCOUNTITEMS")}
          >
            ACCOUNT ITEMS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/taxrates"}
            className="nav-link"
            style={getStyle("TAXRATES")}
          >
          TAXRATES
          </Link>
        </li>
          <li className="nav-item" role="presentation">
          <Link
            to={"/global-taxes"}
            className="nav-link"
            style={getStyle("GLOBALTAXES")}
          >
          GLOBAL TAXES
          </Link>
           </li>
          <li className="nav-item" role="presentation">
          <Link
            to={"/taxcollection"}
            className="nav-link"
            style={getStyle("TAX COLLECTION")}
          >
           TAX COLLECTION
          </Link>
        </li>
         <li className="nav-item" role="presentation">
          <Link
            to={"/taxrules"}
            className="nav-link"
            style={getStyle("TAXRULES")}
          >
          TAXRULES
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default AccountTabs;
